import { Controller } from 'stimulus'

export default class extends Controller {
  openVideoPicker() {
    setTimeout(() => {
      this.dispatch('openAssetPicker', {
        target: window.parent.document,
        detail: {
          setting: 'video',
          field: 'asset_id',
        },
      })
    }, 250)
  }
}
